// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608260904/js/" + chunkId + "." + {"44":"54ee6e8b","225":"4913d124","481":"f279c30d","486":"dd6be67c","770":"ef3fcfe7"}[chunkId] + ".0.10813187644630629.chunk.js";
};